import {
  BioentityLinkParameterConfigSetting,
  DateParameterConfigSetting,
  EntryLinkParameterConfigSetting,
  NumberParameterConfigSetting,
  ProcessLinkParameterConfigSetting,
  ProcessTaskLinkParameterConfigSetting,
  ProjectLinkParameterConfigSetting,
  SelectorParameterConfigSetting,
  StorableLinkParameterConfigSetting,
  StringParameterConfigSetting,
  StudyLinkParameterConfigSetting,
  TeamLinkParameterConfigSetting,
  UserLinkParameterConfigSetting,
} from './ParameterConfigSetting';

export enum ParameterType {
  BIOENTITY_LINK = 'BIOENTITY_LINK',
  DATE = 'DATE',
  ENTRY_LINK = 'ENTRY_LINK',
  FOLDER_LINK = 'FOLDER_LINK',
  NUMBER = 'NUMBER',
  PROCESS_LINK = 'PROCESS_LINK',
  PROCESS_TASK_LINK = 'PROCESS_TASK_LINK',
  PROJECT_LINK = 'PROJECT_LINK',
  SELECTOR = 'SELECTOR',
  STORABLE_LINK = 'STORABLE_LINK',
  STRING = 'STRING',
  STUDY_LINK = 'STUDY_LINK',
  TEAM_LINK = 'TEAM_LINK',
  USER_LINK = 'USER_LINK',
}

export interface BioentityLinkParameterTypeAndConfigSetting {
  type: ParameterType.BIOENTITY_LINK;
  configSetting: BioentityLinkParameterConfigSetting;
}

export interface DateParameterTypeAndConfigSetting {
  type: ParameterType.DATE;
  configSetting: DateParameterConfigSetting;
}

export interface EntryLinkParameterTypeAndConfigSetting {
  type: ParameterType.ENTRY_LINK;
  configSetting: EntryLinkParameterConfigSetting;
}

export interface FolderLinkParameterTypeAndConfigSetting {
  type: ParameterType.ENTRY_LINK;
  configSetting: EntryLinkParameterConfigSetting;
}

export interface NumberParameterTypeAndConfigSetting {
  type: ParameterType.NUMBER;
  configSetting: NumberParameterConfigSetting;
}

export interface ProcessLinkParameterTypeAndConfigSetting {
  type: ParameterType.PROCESS_LINK;
  configSetting: ProcessLinkParameterConfigSetting;
}

export interface ProcessTaskLinkParameterTypeAndConfigSetting {
  type: ParameterType.PROCESS_TASK_LINK;
  configSetting: ProcessTaskLinkParameterConfigSetting;
}

export interface ProjectLinkParameterTypeAndConfigSetting {
  type: ParameterType.PROJECT_LINK;
  configSetting: ProjectLinkParameterConfigSetting;
}

export interface SelectorParameterTypeAndConfigSetting {
  type: ParameterType.SELECTOR;
  configSetting: SelectorParameterConfigSetting;
}

export interface StorableLinkParameterTypeAndConfigSetting {
  type: ParameterType.STORABLE_LINK;
  configSetting: StorableLinkParameterConfigSetting;
}

export interface StringParameterTypeAndConfigSetting {
  type: ParameterType.STRING;
  configSetting: StringParameterConfigSetting;
}

export interface StudyLinkParameterTypeAndConfigSetting {
  type: ParameterType.STUDY_LINK;
  configSetting: StudyLinkParameterConfigSetting;
}

export interface TeamLinkParameterTypeAndConfigSetting {
  type: ParameterType.TEAM_LINK;
  configSetting: TeamLinkParameterConfigSetting;
}

export interface UserLinkParameterTypeAndConfigSetting {
  type: ParameterType.USER_LINK;
  configSetting: UserLinkParameterConfigSetting;
}

export type ParameterTypeAndConfigSetting =
  | BioentityLinkParameterTypeAndConfigSetting
  | DateParameterTypeAndConfigSetting
  | EntryLinkParameterTypeAndConfigSetting
  | FolderLinkParameterTypeAndConfigSetting
  | NumberParameterTypeAndConfigSetting
  | ProcessLinkParameterTypeAndConfigSetting
  | ProcessTaskLinkParameterTypeAndConfigSetting
  | ProjectLinkParameterTypeAndConfigSetting
  | SelectorParameterTypeAndConfigSetting
  | StorableLinkParameterTypeAndConfigSetting
  | StringParameterTypeAndConfigSetting
  | StudyLinkParameterTypeAndConfigSetting
  | TeamLinkParameterTypeAndConfigSetting
  | UserLinkParameterTypeAndConfigSetting;
